import { useEffect, useState } from "react";
import { Sun, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { DecreeList } from "@/components/DecreeList";

export default function DailyDecree() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/daily-decree").then((res) => setData(res.data)).catch(() => setError(true));
  }, []);

  const prettyDate = data?.date
    ? new Date(data.date + "T00:00:00").toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric", year: "numeric" })
    : "";

  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-8 pt-12 sm:pt-16 pb-24">
      <div className="flex items-center gap-3 mb-6">
        <Sun className="w-6 h-6 text-[#2C2A29]" strokeWidth={1.5} />
        <p className="font-body text-sm uppercase tracking-[0.2em] text-[#7A756E]">Daily Decree</p>
      </div>

      {!data && !error && (
        <div className="text-center py-24" data-testid="daily-loading">
          <Loader2 className="w-8 h-8 text-[#2C2A29] animate-spin mx-auto" />
          <p className="font-decree text-xl text-[#4A4744] mt-6">Preparing today's decree…</p>
        </div>
      )}

      {error && (
        <p className="font-decree text-xl text-[#9B3B3B] mt-8">Could not load today's decree. Please try again later.</p>
      )}

      {data && (
        <div data-testid="daily-decree">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#2C2A29] tracking-tight capitalize">
            {data.topic}
          </h1>
          <p className="font-body text-sm text-[#7A756E] mt-2 mb-10">{prettyDate}</p>
          <DecreeList session={{ intro: "Speak today's decree aloud with faith and authority.", topic: data.topic, decrees: data.decrees, word_study: data.word_study }} />
        </div>
      )}
    </div>
  );
}
